import config from "environment";
import { getRequest, postRequest } from "./client";
import { User } from "effno-core";

const { baseApi } = config;

export async function apiGetUser(id: string) {
  const fetchURL = `${baseApi}/users/${id}`;
  return await getRequest(fetchURL, "API/apiGetUser");
}

export async function apiGetUserByEmail(email: string) : Promise<User | null> {
  const fetchURL = `${baseApi}/users/by-email`;
  return await postRequest(fetchURL, { email }, "API/apiGetUserByEmail");
}

export async function apiGetUserByUsername(username: string) {
  const fetchURL = `${baseApi}/users/by-username/${username}`;
  return await getRequest(fetchURL, "API/apiGetUserByUsername");
}

export async function apiSetUserTheme(userId: string, theme: string) {
  const fetchURL = `${baseApi}/users/set-theme`;
  return await postRequest(fetchURL, { userId, theme }, "API/apiSetUserTheme");
}

// this returns the user record of the new user or null
export async function apiCreateUserWithWorkspace(
  firstName: string,
  lastName: string,
  email: string | undefined,
  avatarURL: string | null,
  password: string | null,
) {
  const fetchURL = `${baseApi}/users/create-user-with-workspace`;

  return await postRequest(
    fetchURL,
    { firstName, lastName, email, avatarURL, password },
    "API/apiCreateUserWithWorkspace"
  );
}

export async function apiSyncAvatar(userId: string, avatarUrl: string) {
  const fetchURL = `${baseApi}/users/sync-avatar`;

  return await postRequest(
    fetchURL,
    { userId, avatarUrl },
    "API/apiSyncAvatar"
  );
}

export async function apiSaveUser(user: User) {
  const fetchURL = `${baseApi}/users/update`;
  return await postRequest(fetchURL, user, "API/apiSaveUser");
}

export async function apiUpsertUser(payload: any) {
  const fetchURL = `${baseApi}/users/upsert`;
  return await postRequest(fetchURL, payload, "API/apiUpsertUser");
}